<div
  #dropBox
  [ngClass]="{ 'image-uploader-container': true, dragover: dragover }"
  (drop)="handleDropEvent($event)"
  (dragover)="dragover = true"
  (dragenter)="dragover = true"
  (dragleave)="dragover = false"
  (dragend)="dragover = false"
>
  <div
    *ngIf="!value?.url && (isUploading$$ | async) === false && !disabled"
    class="prompt content"
  >
    <span>
      {{
        'FRONTEND.FORMS.IMAGE_UPLOAD.DROP_NOUN_HERE'
          | translate: { imageNoun: imageNoun }
      }}
    </span>
    <span class="spacer">
      {{ 'FRONTEND.FORMS.IMAGE_UPLOAD.OR' | translate }}
    </span>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="fileInput.click()"
    >
      {{
        'FRONTEND.FORMS.IMAGE_UPLOAD.UPLOAD_NOUN'
          | translate: { imageNoun: imageNoun }
      }}
    </button>
    <span class="hint" *ngIf="maxFileSize && showMaxFileSize">
      {{
        'FRONTEND.FORMS.IMAGE_UPLOAD.MAX_FILE_SIZE'
          | translate: { sizeInMb: _maxFileSizeMb }
      }}
    </span>
  </div>
  <div *ngIf="disabled" class="prompt content">
    <span>{{ 'FRONTEND.FORMS.IMAGE_UPLOAD.DISABLED' | translate }}</span>
  </div>

  <div *ngIf="isUploading$$ | async" class="content">
    <mat-spinner [diameter]="60" mode="indeterminate"></mat-spinner>
  </div>

  <div
    *ngIf="value && value.url && (isUploading$$ | async) === false"
    class="content preview"
  >
    <img [src]="value.url" (click)="fileInput.click()" />
  </div>

  <button
    class="clear-button"
    mat-icon-button
    *ngIf="showClear && value?.url"
    (click)="clearValue()"
    type="button"
  >
    <mat-icon>close</mat-icon>
  </button>

  <input
    #fileInput
    type="file"
    (change)="handleInputChange()"
    class="hide-default-input"
    [accept]="acceptedMimeTypes"
  />
</div>
<ng-content selector="[error]"></ng-content>
